import { FC, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import churnzeroService from '../../../services/churnzero/churnzero-service';
import AuthService from '../../../services/auth/authService';

const ChurnZero: FC = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { user } = useSelector((state: any) => state, shallowEqual);
  useEffect(() => {
    if (!user.userLoggedIn) return;
    const token = AuthService.getAuthToken();
    if (user.currentUserId && user.currentUserFirstName && user.currentUserLastName && user.organization) {
      churnzeroService.loginUser(
        user.currentUserId,
        user.currentUserFirstName,
        user.currentUserLastName,
        user.organization,
        token
      );
    }
  }, [user.userLoggedIn]);

  return <span id="churn-zero"></span>;
};

export default ChurnZero;
